<template>
  <div>
    <van-action-sheet
      v-model="show"
      title="缴款记录"
      @cancel="onCancel"
      class="pay-record-sheet"
    >
      <van-tabs
        v-model="activeItem"
        @change="onItemTabClick"
        class="custom-tabs"
      >
        <van-tab>
          <template #title>
            <van-icon name="gold-coin-o" />&nbsp;缴/退费凭证
          </template>
        </van-tab>
        <van-tab>
          <template #title>
            <van-icon name="underway" />&nbsp;订单明细
          </template>
        </van-tab>
      </van-tabs>

      <!-- 缴/退费凭证 -->
      <div
        v-if="activeItem === 0 && resultList.length > 0"
        class="certificate-container"
      >
        <div class="certificate-card">
          <!-- 赛事图片 -->
          <div class="certificate-image-wrapper">
            <van-swipe
              class="certificate-swipe"
              :autoplay="3000"
              indicator-color="white"
            >
              <van-swipe-item>
                <img
                  class="certificate-image"
                  :src="resultList[0].LOGO"
                  alt="赛事图片"
                />
              </van-swipe-item>
            </van-swipe>
          </div>

          <!-- 赛事标题 -->
          <div class="certificate-title">
            <van-icon name="award-o" class="title-icon" />
            <span class="title-text">{{ resultList[0].SSMC }}（凭证）</span>
          </div>

          <!-- 凭证信息 -->
          <div class="certificate-info">
            <div class="info-section">
              <div class="section-header">
                <van-icon name="calendar-o" class="section-icon" />
                <span class="section-title">赛事信息</span>
              </div>
              <div class="info-row">
                <span class="info-label">比赛时间</span>
                <span class="info-value"
                  >{{ resultList[0].STARTDATE }} 至
                  {{ resultList[0].ENDDATE }}</span
                >
              </div>
              <div class="info-row">
                <span class="info-label">比赛地点</span>
                <span class="info-value">{{ resultList[0].CGMC }}</span>
              </div>
            </div>

            <div class="info-section">
              <div class="section-header">
                <van-icon name="flag-o" class="section-icon" />
                <span class="section-title">报名信息</span>
              </div>
              <div class="info-row">
                <span class="info-label">报名组别</span>
                <span class="info-value">{{ resultList[0].XMJC }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">报名项目</span>
                <span class="info-value">{{ resultList[0].XMLXMC }}</span>
              </div>
            </div>

            <div class="info-section">
              <div class="section-header">
                <van-icon name="friends-o" class="section-icon" />
                <span class="section-title">运动员信息</span>
              </div>
              <div class="info-row">
                <span class="info-label">姓名1</span>
                <span class="info-value">{{ resultList[0].RYXM1 }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">证件号1</span>
                <span class="info-value">{{ resultList[0].SFZH1 }}</span>
              </div>
              <div class="info-row" v-if="resultList[0].RYXM2.length > 0">
                <span class="info-label">姓名2</span>
                <span class="info-value">{{ resultList[0].RYXM2 }}</span>
              </div>
              <div
                class="info-row"
                v-if="
                  resultList[0].SFZH2.length > 0 && resultList[0].SFZH2 !== '-'
                "
              >
                <span class="info-label">证件号2</span>
                <span class="info-value">{{ resultList[0].SFZH2 }}</span>
              </div>
            </div>

            <div class="info-section payment-section">
              <div class="section-header">
                <van-icon name="gold-coin-o" class="section-icon" />
                <span class="section-title">缴费信息</span>
              </div>
              <div class="info-row highlight">
                <span class="info-label">缴费总笔数</span>
                <span class="info-value">1笔</span>
              </div>
              <div class="info-row highlight">
                <span class="info-label">缴费总金额</span>
                <span class="info-value amount">{{ resultList[0].SJJE }}</span>
              </div>
              <div class="info-row validity">
                <span class="info-label">凭证有效期</span>
                <span class="info-value"
                  >{{ resultList[0].ENDDATE }} 前有效</span
                >
              </div>
            </div>
          </div>

          <!-- 成功印章 -->
          <img
            src="https://www.ptty.com.cn/wap/successSh.png"
            class="success-stamp"
            alt="成功印章"
          />
        </div>
      </div>

      <!-- 订单明细 -->
      <div
        v-if="resultList.length > 0 && activeItem === 1"
        class="order-list-container"
      >
        <div
          class="order-card"
          v-for="(item, index) in resultList"
          :key="index"
        >
          <div class="order-header">
            <van-icon name="orders-o" class="order-icon" />
            <span class="order-number">订单号：{{ item.YHDDH }}</span>
          </div>

          <div class="order-body">
            <div class="order-section">
              <div class="order-row">
                <span class="order-label">组别</span>
                <span class="order-value">{{ item.XMJC }}</span>
              </div>
              <div class="order-row">
                <span class="order-label">项目</span>
                <span
                  class="order-value"
                  v-if="
                    ssid !==
                      '69736c3638616f7575746b79664f736b334f425763314a66314841587771497a'
                  "
                >
                  {{ item.SSLX }}
                </span>
                <span class="order-value" v-else>
                  {{ item.SSLX.substr(0, 1) === "M" ? "男子" : "女子" }}
                </span>
              </div>
              <div class="order-row">
                <span class="order-label">运动员信息</span>
                <span
                  class="order-value"
                  v-if="item.SSLX && item.SSLX.substr(1, 2) === 'D'"
                >
                  {{ item.RYXM1 }} / {{ item.RYXM2 }}
                </span>
                <span v-else class="order-value">
                  {{ item.RYXM1 }}
                </span>
              </div>
            </div>

            <div class="order-section payment-info">
              <div class="order-row">
                <span class="order-label">订单金额</span>
                <span class="order-value price">{{ item.DDJE }}元</span>
              </div>
              <div class="order-row">
                <span class="order-label">{{
                  item.SSLX && item.SSLX.substr(1, 2) === "D"
                    ? "运动员1优惠"
                    : "运动员优惠"
                }}</span>
                <span class="order-value discount">{{ item.HYYHJE1 }}元</span>
              </div>
              <div
                class="order-row"
                v-if="item.SSLX && item.SSLX.substr(1, 2) === 'D'"
              >
                <span class="order-label">运动员2优惠</span>
                <span class="order-value discount">{{ item.HYYHJE2 }}元</span>
              </div>
              <div class="order-row highlight-row">
                <span class="order-label">实交金额</span>
                <span class="order-value final-price">{{ item.SJJE }}元</span>
              </div>
            </div>

            <div class="order-section">
              <div class="order-row">
                <span class="order-label">交易时间</span>
                <span class="order-value">{{ item.JYSJ }}</span>
              </div>
              <div class="order-row">
                <span class="order-label">支付人</span>
                <span class="order-value">{{ item.SJZFXM }}</span>
              </div>
              <div class="order-row">
                <span class="order-label">是否退付</span>
                <span
                  class="order-value"
                  :class="item.ISTF === '1' ? 'refund-yes' : 'refund-no'"
                >
                  {{ item.ISTF === "0" ? "否" : "是" }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="resultList.length === 0" class="empty-state">
        <van-icon name="records" class="empty-icon" />
        <p class="empty-text">暂无订单记录</p>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: "PayRecordCom",
  components: {},
  data() {
    return {
      show: false,
      ssid: "",
      reqDatas: [],
      utilPost: "",
      op: "payGl",
      resultList: [],
      activeItem: 0
    };
  },
  mounted() {
    this.utilPost = this.$util.handler;
  },
  methods: {
    onItemTabClick() {},
    mainLoadData: function() {
      var busData = this.reqDatas;
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getYhddRecord" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        // alert(JSON.stringify(data));
        this.resultList = data.content;
      });
    },
    setData: function(reqDatas, ssid) {
      this.ssid = ssid;
      this.reqDatas = reqDatas;
      this.mainLoadData();
    },
    openPayModal: function() {
      this.show = true;
    },
    onCancel: function() {
      this.show = false;
      this.$emit("update:isPay", false);
    }
  }
};
</script>
<style scoped>
/* 🎨 整体容器 */
.pay-record-sheet >>> .van-action-sheet__header {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  font-weight: 700;
  font-size: 1.125rem;
  padding: 1rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.van-action-sheet {
  max-height: 90% !important;
}

/* 🎨 标签页样式 */
.custom-tabs {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.custom-tabs >>> .van-tabs__nav {
  background: #fff;
}

.custom-tabs >>> .van-tab {
  color: #666;
  font-weight: 500;
  font-size: 0.9375rem;
}

.custom-tabs >>> .van-tab--active {
  color: #185f9b;
  font-weight: 700;
}

.custom-tabs >>> .van-tabs__line {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  height: 3px;
  border-radius: 3px;
}

/* ==================== 缴/退费凭证样式 ==================== */
.certificate-container {
  padding: 1rem;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
  min-height: 60vh;
  position: relative;
}

.certificate-card {
  background: #fff;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(24, 95, 155, 0.15);
  position: relative;
}

/* 图片区域 */
.certificate-image-wrapper {
  position: relative;
  overflow: hidden;
}

.certificate-swipe {
  height: 12.25rem;
}

.certificate-image {
  width: 100%;
  height: 12.25rem;
  object-fit: cover;
}

/* 标题区域 */
.certificate-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  background: linear-gradient(
    135deg,
    rgba(24, 95, 155, 0.08) 0%,
    rgba(34, 115, 175, 0.08) 100%
  );
  border-bottom: 2px solid #185f9b;
}

.title-icon {
  font-size: 1.5rem;
  color: #185f9b;
}

.title-text {
  font-size: 1.0625rem;
  font-weight: 700;
  color: #2c3e50;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 信息区域 */
.certificate-info {
  padding: 1rem;
}

.info-section {
  margin-bottom: 1.25rem;
  background: #f8f9fa;
  border-radius: 0.75rem;
  padding: 0.875rem;
  border-left: 4px solid #185f9b;
}

.info-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.section-icon {
  font-size: 1.125rem;
  color: #185f9b;
}

.section-title {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #374151;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.625rem 0;
  border-bottom: 1px dashed #e5e7eb;
}

.info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.info-label {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  flex-shrink: 0;
  margin-right: 1rem;
}

.info-value {
  font-size: 0.875rem;
  color: #1f2937;
  font-weight: 600;
  text-align: right;
  word-break: break-all;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 缴费信息特殊样式 */
.payment-section {
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  border-left-color: #f97316;
}

.payment-section .section-icon {
  color: #f97316;
}

.info-row.highlight {
  background: rgba(249, 115, 22, 0.08);
  padding: 0.625rem 0.75rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  border-bottom: none;
}

.info-row.highlight:last-child {
  margin-bottom: 0;
}

.info-value.amount {
  color: #ea580c;
  font-size: 1.125rem;
  font-weight: 700;
}

.info-row.validity {
  background: rgba(16, 185, 129, 0.08);
  padding: 0.625rem 0.75rem;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
}

.info-row.validity .info-value {
  color: #059669;
  font-weight: 700;
}

/* 成功印章 */
.success-stamp {
  width: 7.625rem;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.85;
  pointer-events: none;
  z-index: 5;
}

/* ==================== 订单明细样式 ==================== */
.order-list-container {
  padding: 1rem;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
  min-height: 60vh;
}

.order-card {
  background: #fff;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.12);
  margin-bottom: 1rem;
}

.order-card:last-child {
  margin-bottom: 0;
}

.order-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

.order-icon {
  font-size: 1.25rem;
  color: #fff;
}

.order-number {
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.order-body {
  padding: 1rem;
}

.order-section {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.order-section:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.order-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.order-label {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  flex-shrink: 0;
  margin-right: 1rem;
}

.order-value {
  font-size: 0.875rem;
  color: #1f2937;
  font-weight: 600;
  text-align: right;
  word-break: break-all;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 金额相关样式 */
.payment-info {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border-radius: 0.75rem;
  padding: 0.75rem;
  border: 1px solid #fbbf24;
}

.order-value.price {
  color: #d97706;
  font-weight: 700;
}

.order-value.discount {
  color: #10b981;
  font-weight: 700;
}

.order-row.highlight-row {
  background: rgba(217, 119, 6, 0.1);
  padding: 0.625rem 0.75rem;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
}

.order-value.final-price {
  color: #dc2626;
  font-size: 1.0625rem;
  font-weight: 700;
}

/* 退付状态 */
.order-value.refund-yes {
  color: #dc2626;
  font-weight: 700;
}

.order-value.refund-no {
  color: #10b981;
  font-weight: 700;
}

/* ==================== 空状态样式 ==================== */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  min-height: 15rem;
}

.empty-icon {
  font-size: 4rem;
  color: #d1d5db;
  margin-bottom: 1rem;
}

.empty-text {
  font-size: 0.9375rem;
  color: #9ca3af;
  font-weight: 500;
  margin: 0;
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 375px) {
  .certificate-title {
    padding: 0.75rem;
  }

  .title-text {
    font-size: 0.9375rem;
  }

  .info-label,
  .info-value,
  .order-label,
  .order-value {
    font-size: 0.8125rem;
  }

  .success-stamp {
    width: 6.25rem;
  }
}

/* ==================== 滚动条美化 ==================== */
.certificate-container::-webkit-scrollbar,
.order-list-container::-webkit-scrollbar {
  width: 6px;
}

.certificate-container::-webkit-scrollbar-thumb,
.order-list-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border-radius: 3px;
}

.certificate-container::-webkit-scrollbar-track,
.order-list-container::-webkit-scrollbar-track {
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/PayRecordCom.vue